var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgeA10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 32,
    viewBox: "0 0 50 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 32,
    rx: 6,
    fill: "#0095DA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.84497 24L10.989 7.2H14.445L20.589 24H17.325L15.981 20.112H9.42897L8.06097 24H4.84497ZM10.269 17.712H15.141L12.693 10.728L10.269 17.712ZM23.8505 24V10.704L21.0905 11.352V9L25.1465 7.2H27.0425V24H23.8505ZM37.188 24.288C35.636 24.288 34.308 23.928 33.204 23.208C32.1 22.472 31.244 21.456 30.636 20.16C30.044 18.848 29.748 17.328 29.748 15.6C29.748 13.888 30.044 12.376 30.636 11.064C31.244 9.752 32.1 8.736 33.204 8.016C34.308 7.28 35.636 6.912 37.188 6.912C38.74 6.912 40.068 7.28 41.172 8.016C42.276 8.736 43.124 9.752 43.716 11.064C44.324 12.376 44.628 13.888 44.628 15.6C44.628 17.328 44.324 18.848 43.716 20.16C43.124 21.456 42.276 22.472 41.172 23.208C40.068 23.928 38.74 24.288 37.188 24.288ZM37.188 21.528C38.452 21.528 39.484 21 40.284 19.944C41.084 18.888 41.484 17.44 41.484 15.6C41.484 13.76 41.084 12.312 40.284 11.256C39.484 10.2 38.452 9.672 37.188 9.672C35.908 9.672 34.868 10.2 34.068 11.256C33.284 12.312 32.892 13.76 32.892 15.6C32.892 17.44 33.284 18.888 34.068 19.944C34.868 21 35.908 21.528 37.188 21.528Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgeA10);
export default __webpack_public_path__ + "static/media/age-a10.832d9bc99792671ecdbbb13f64d5ee97.svg";
export { ForwardRef as ReactComponent };